import {createFileRoute} from '@tanstack/react-router';

import {SessionsPage} from '@/modules/auth/pages/SessionsPage';

export const Route = createFileRoute('/_authenticated/account/sessions')({
  component: SessionsPage,
});
